import { render, staticRenderFns } from "./LinkDetail.vue?vue&type=template&id=7c2274ae&scoped=true"
import script from "./LinkDetail.vue?vue&type=script&lang=js"
export * from "./LinkDetail.vue?vue&type=script&lang=js"
import style0 from "./LinkDetail.vue?vue&type=style&index=0&id=7c2274ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2274ae",
  null
  
)

export default component.exports